import { createSlice } from '@reduxjs/toolkit'
import { fetchFacilityBasicInfo } from './hotel-facility-thunks'

type StateType = {
  loading: boolean
  isFetched: boolean
  error: string | undefined
  basicInfo: any
}

export const hotelFacilitySlice = createSlice({
  name: 'hotelFacility',
  initialState: {
    loading: false,
    isFetched: false,
    error: undefined,
    basicInfo: undefined,
  } as StateType,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchFacilityBasicInfo.fulfilled, (state, action) => {
      state.loading = false
      state.isFetched = true
      state.basicInfo = action.payload?.basicInfo
    })
    builder.addCase(fetchFacilityBasicInfo.pending, state => {
      state.loading = true
    })
    builder.addCase(fetchFacilityBasicInfo.rejected, (state, action) => {
      state.loading = false
      state.isFetched = false
      state.error = action.error.message || 'Unknown error'
    })
  },
})

export const hotelFacilityReducer = hotelFacilitySlice.reducer
